// Called by : src/components/lesson/LessonItem.vue (modal-eval)

<template>
  <base-modal ref="base-modal" :pageId="'modal_eval_' + zkp" pageClass="eval" modalClass="modal-md" modalDataBack="true" modalDataKey="true" :key="keyModal">

    <template #header>
      <h4 class="modal-title" id="pge_eval_title">{{ $t("evaluation.modalEvalTitle") }}</h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>

    <template #body>
      <div class="text-left my-3" style="font-size: 1.2em;">
        <p class="">{{ $t("evaluation.modalEvalBody") }}</p>
      </div>

      <div class="form_cont px-0">

        <div class="input-group text-left">
          <label class="input-group-prepend w-50" for="passEval">
            <span class="input-group-text px-xs-2 px-sm-3 w-100"><span class="oi oi-lock-locked text-muted pr-2"></span>{{ $t("evaluation.modalEvalPass") }}</span>
          </label>
          <input type="text" :id="'passEval_' + zkp" ref="rPss" class="form-control" v-model="passEval" autofocus required>
        </div>

      </div> <!-- .form_cont password -->
    </template>

    <template #footer>
      <div class="btn-group bnt-block w-100">
        <button class="btn btn-secondary btn-md" data-dismiss="modal" @click.stop="refuse" style="width:40%;">
          <span class="oi oi-ban mr-2"></span>
          {{ $t("modals.cancel") }}
        </button>
        <button type="submit" class="btn btn-primary btn-md btn_modal_submit" data-dismiss="modal" :disabled="getDisabled()" @click.stop="save" style="width:60%;">
          <span class="oi oi-check mr-2"></span>
          {{ $t("modals.validate") }}
        </button>
      </div>
    </template>

    {{ forceRefresh }}

  </base-modal>
</template>

<script>
import { constants } from '@/constants'
import BaseModal from '@/components/BaseModal'

export default {
  props: {
    pass: String,
    zkp: String,
  },
  components: {
    BaseModal,
  },
  data() {
    return {
      passEval: '',
      keyModal: false,
    }
  },
  methods: {
    getKey(sId) {
      return sId + f_getRandomMinMax_n(100000000, 999999999);
    },
    getDisabled() {
      return Boolean(!this.passEval);
    },
    save() {
      var sPassEval = this.passEval;
      this.passEval = '';
      $('#modal_eval_' + this.zkp).modal('hide');
      this.$emit('save', sPassEval);
    },
    refuse() {
      this.passEval = '';
      $('#modal_eval_' + this.zkp).modal('hide');
    },
  },
  computed: {
    forceUpdate() {
      return '';
    },
    forceRefresh() {
      if (!this.keyModal) this.keyModal = this.getKey('ModalEval');
      return '';
    },
    constants() {
      return constants
    },
  },
  mounted: function() {
    this.passEval = '';
    this.keyModal = false;
  },
}
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/misc/ModalEval.vue